import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, useState, useCallback, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { Navbar } from '../Navbar/Navbar';
import { NavigationItem, NavigationSidebar } from '../NavigationSidebar/NavigationSidebar';
import { SynchronizationStatusSidebar } from '../SynchronizationStatusSidebar/SynchronizationStatusSidebar';
export type DefaultPageLayoutProps = PropsWithChildren<{
  navigationItems: Array<NavigationItem>;
  onLogoutClick: () => void;
  onOpenUserProfile: () => void;
}>;
export const DefaultPageLayout: FunctionComponent<DefaultPageLayoutProps> = React.memo(props => {
  const $ = _c(20);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children,
    navigationItems,
    onLogoutClick,
    onOpenUserProfile
  } = t0;
  const [navigationSidebarOpened, setNavigationSidebarOpened] = useState(false);
  const [synchronizationStatusSidebarOpened, setSynchronizationStatusOpened] = useState(false);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setNavigationSidebarOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleMenuIconClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSynchronizationStatusOpened(true);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSyncIconClick = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setNavigationSidebarOpened(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCloseNavigationSidebar = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSynchronizationStatusOpened(false);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleCloseSynchronizationStatusSidebar = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Navbar onMenuIconClick={handleMenuIconClick} onSyncIconClick={handleSyncIconClick} data-testid="DefaultPageLayout.Navbar" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== navigationItems || $[8] !== navigationSidebarOpened || $[9] !== onLogoutClick || $[10] !== onOpenUserProfile) {
    t6 = <NavigationSidebar opened={navigationSidebarOpened} navigationItems={navigationItems} onCloseSidebar={handleCloseNavigationSidebar} onLogoutClick={onLogoutClick} onOpenUserProfile={onOpenUserProfile} data-testid="DefaultPageLayout.NavigationSidebar" />;
    $[7] = navigationItems;
    $[8] = navigationSidebarOpened;
    $[9] = onLogoutClick;
    $[10] = onOpenUserProfile;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== synchronizationStatusSidebarOpened) {
    t7 = <SynchronizationStatusSidebar opened={synchronizationStatusSidebarOpened} onCloseSidebar={handleCloseSynchronizationStatusSidebar} data-testid="DefaultPageLayout.SynchronizationStatusSidebar" />;
    $[12] = synchronizationStatusSidebarOpened;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children) {
    t8 = <div>{children}</div>;
    $[14] = children;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <>{t5}{t6}{t7}{t8}</>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
});